export default "__VITE_ASSET__BBCSYx0J__"